import * as React from 'react';

import Button, { ButtonType } from 'components/basic/Button';
import UseFormStyles from 'styles/FormStyles';
import { useEorzeanClockOption } from 'hooks/options';

export interface ShowEorzeanTimeOptionProps {}

const ShowEorzeanTimeOption = (props: ShowEorzeanTimeOptionProps): React.ReactElement => {
  const [is_visible, set_is_visible] = useEorzeanClockOption();
  const styles = UseFormStyles();

  const checkbox_style = is_visible ? styles.checked : styles.unchecked;

  return (
    <Button
      type={ButtonType.FlatText}
      on_click={() => set_is_visible(!is_visible)}
    >
      <div className={`${styles.checkbox} ${checkbox_style}`}></div>
      Show Eorzean clock
    </Button>
  );
};

export default ShowEorzeanTimeOption;